module.exports = __webpack_public_path__ + "static/media/CI.02796bef.svg";